import { IntlShape } from 'react-intl';

export const dictionary = {
    home__benefits__family_card__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.43095d40721254d9b024b3b1a009e7d7',
            defaultMessage: 'Invite your family members',
            description: 'Заголовок карточки',
        }),
    home__allplay__benefits__family_card__subtitle: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.3f1b0be08f9533db4d33806f183982ce',
            defaultMessage: 'Connect up to 20 devices between you and 3 more members',
            description: 'Подзаголовок карточки',
        }),
    home__benefits__family_card__subtitle: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.f163d75635d65d1797369737b96b8f20',
            defaultMessage: 'Connect up to 20 devices between\nyou and 3 more members',
            description: 'Подзаголовок карточки',
        }),
    home__benefits__watch_card__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.d1f7223d5f0560c27795d21d5ac32e9d',
            defaultMessage: 'Watch any way you want',
            description: 'Заголовок карточки',
        }),
    home__benefits__watch_card__subtitle: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.d9aff20b49c50d6a3d02b389f2bcbd63',
            defaultMessage:
                'Оn mobile, tablet, laptop, Smart TV, PlayStation, Android TV, Apple TV, and more',
            description: 'Подзаголовок карточки',
        }),
    home__allplay__benefits__watch_card__subtitle: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.364e098108f5f4fbefcc1748bf57dfe4',
            defaultMessage: 'Оn mobile, tablet, laptop and Smart TV',
            description: 'Подзаголовок карточки',
        }),
    home__benefits__download_card__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.d5f797e187549db1d426b8d121ca64cf',
            defaultMessage: 'Download and enjoy offline',
            description: 'Заголовок карточки',
        }),
    home__benefits__download_card__subtitle: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.22c5a70a655fae2010595cdc9065d969',
            defaultMessage: 'Watch your favorite movies and series and listen to music at any time',
            description: 'Подзаголовок карточки',
        }),
    home__allplay__benefits__download_card__subtitle: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.d657867ac983ae6add7754437ce91327',
            defaultMessage: 'Watch your favorite movies and series at any time',
            description: 'Подзаголовок карточки',
        }),
    home__benefits__taxi_card__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.home.i18n.c522eda6871eff4832ccd7e51c740002',
            defaultMessage: 'Get 50% back on rides',
            description: 'Заголовок карточки',
        }),
    home__benefits__my_vibe: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.home.i18n.1dcd0b4631cbe19458c7bf958758de4f',
            defaultMessage: 'My Vibe',
            description: 'Заголовок карточки',
        }),

    home__benefits__personalized_playlists: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.home.i18n.63d98680031a2f8df94ca1de4af85ac7',
            defaultMessage: 'Personalized AI-curated playlists based on your mood and activity',
            description: 'Подзаголовок карточки',
        }),
    home__benefits__taxi_card__subtitle: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.9fdacbee75d2f85ac87b708a57dd88b4',
            defaultMessage: 'Book your Comfort ride with Yango Taxi\nin Abu Dhabi',
            description: 'Подзаголовок карточки',
        }),
    home__benefits__subtitle: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.0979d129cd02cc26e60d899500a87b13',
            defaultMessage: 'More benefits',
            description: 'Подзаголовок блока преимуществ',
        }),
    home__benefits__cta__get_started: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.be11c74c1dd7f307bb80183a90dc2067',
            defaultMessage: 'Get started',
            description: 'Текст кнопки входа в профиль на логинволе',
        }),

    home__music__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.home.i18n.24503b0dfd10ed658168550f0b3dd3bd',
            defaultMessage: 'YANGO MUSIC',
            description: 'Заголовок блока музыки',
        }),
    home__music__subtitle: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.home.i18n.63fb884c690a68dc14861bb4b694ae60',
            defaultMessage: 'Listen to curated playlists',
            description: 'Подзаголовок блока музыки',
        }),
    home__music__description: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.home.i18n.3f2f7da44b507d5729f7d692d9679a23',
            defaultMessage:
                'Millions of tracks, fresh releases, and personal recommendations based on your taste',
            description: 'Описание блока музыки',
        }),
    home__music__cta__get_app: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.8d7dd5349a74f80ab16beaae53eff66a',
            defaultMessage: 'Get the Mobile App',
            description: 'Текст кнопки загрузки мобильного приложения',
        }),
    home__music__cta__explore: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.home.i18n.58fe62a172f50f85eb9c1818e57f4084',
            defaultMessage: 'Explore Music',
            description: 'Текст кнопки перехода на лендинг Yango Music',
        }),

    home__tv_channels__cta__get_started: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.be11c74c1dd7f307bb80183a90dc2067',
            defaultMessage: 'Get started',
            description: 'Текст кнопки входа в профиль на логинволе',
        }),
    plus_infoblock_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.home.i18n.0b990c12cb6e4841229c0f3bf180f20a',
            defaultMessage: 'One account, endless benefits',
            description: 'Plus Infoblock title on the main page',
        }),
    plus_info_block__item1: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.home.i18n.3dd44bd2db39299039944dd3d1cf49b1',
            defaultMessage: 'Enjoy movies and series on Yango Play',
            description: 'Plus Infoblock benefit yango',
        }),
    plus_info_block__item2: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.home.i18n.00205887d4b35dca19a0727be1029041',
            defaultMessage: 'Discover trending hits on Yango Play Music',
            description: 'Plus Infoblock benefit yango music',
        }),
    plus_info_block__item3: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.home.i18n.61732950547566897461dfa1c457db6c',
            defaultMessage: 'Ride in comfort with Yango Rides',
            description: 'Plus Infoblock benefit yango taxi',
        }),
    home__showcase_header_title_base: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.6fc35dc7032157099e665b1ce06e07ef',
            defaultMessage: 'Movies and series',
            description: 'Заголовок витрины на онбординге',
        }),
    home__showcase_header_subtitle_base: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.686adfe7dda60f58b6472842c6aac7f7',
            defaultMessage: 'High quality and ad-free',
            description: 'Подзаголовок витрины на онбординге',
        }),
    home__showcase_header_title_extra: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.232a31b9112b826d55d7135cd5e0c3b1',
            defaultMessage: 'Crunchyroll',
            description: 'Заголовок витрины на онбординге',
        }),
    home__showcase_header_subtitle_extra: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.013e3c05fb9ae1e024d8dbf394ed75d7',
            defaultMessage: 'anime library',
            description: 'Подзаголовок витрины на онбординге',
        }),
};
